module.exports = __webpack_public_path__ + "static/the-game-of-kings-26d50a0ba677a772a1de90119009c949.jpg";